var __webpack_exports__ = {};
/*!********************************!*\
  !*** ./src/scripts/masonry.js ***!
  \********************************/
class masonryGrid extends HTMLElement {
  constructor() {
    super()
    this.grid = this.querySelector('.masonry');
    this.visualWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
  }
  connectedCallback() {
    if (this.visualWidth > 750) {
      this.msnry = new Masonry( this.grid, {
        // options
        itemSelector: '.masonry-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
      });

      window.msnry = this.msnry;
    }
  }

}
customElements.define('masonry-grid', masonryGrid)



